import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { GeneralModule } from '../general/general.module';
import { EnableVUModeComponent } from './components/enable-vu-mode/enable-vu-mode.component';
import { VuCommunicationService } from './services/vu-communication.service';
import { VuConnectionHttpService } from './services/vu-connection-http.service';
import { TouchKeyboardService } from './services/touch-keyboard.service';
import { TouchTileService } from './services/touch-tile.service';
import { VuPaymentCompleteComponent } from './components/vu-payment-complete/vu-payment-complete.component';
import { TranslateModule } from '@ngx-translate/core';
import { ScreenSaverService } from './services/screen-saver.service';
import { ScreenSaverComponent } from './components/screen-saver/screen-saver.component';
import { VuConfigurationService } from './services/vu-configuration.service';

const routes: Routes = [
  {
    path: 'vu',
    component: EnableVUModeComponent,
    pathMatch: 'full',
  },
  {
    path: 'payment/vu-complete',
    component: VuPaymentCompleteComponent,
    pathMatch: 'full',
  },
  {
    path: 'screen-saver', component: ScreenSaverComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule.forChild(routes),
    GeneralModule,
    TranslateModule,
  ],
  declarations: [
    EnableVUModeComponent,
    VuPaymentCompleteComponent,
    ScreenSaverComponent,
  ],
  providers: [
    VuCommunicationService,
    VuConnectionHttpService,
    VuConfigurationService,
    TouchKeyboardService,
    TouchTileService,
    ScreenSaverService,
  ]
})
export class VUModule { }
